import { Box, Drawer, IconButton, Typography, Divider, Button } from "@mui/material";
import { Close as CloseIcon, PsychologyOutlined } from "@mui/icons-material";
import ExtractedGoalsPanel from "./ExtractedGoalsPanel";
import AILoadingMessages from "./AILoadingMessages";

interface ExtractGoalsDrawerProps {
  open: boolean;
  onClose: () => void;
  goals: string[];
  loading: boolean;
  participantId: string;
  noteId?: string;
  onLoadingComplete?: () => void;
  onGoalsCreated: () => void;
}

const ExtractGoalsDrawer = ({
  open,
  onClose,
  goals,
  loading,
  participantId,
  noteId,
  onLoadingComplete,
  onGoalsCreated,
}: ExtractGoalsDrawerProps) => {
  const handleGoalsCreated = () => {
    onGoalsCreated();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "600px", md: "700px" },
          maxWidth: "700px",
        },
      }}
    >
      <Box sx={{ p: 3, height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography variant="subtitle2" fontWeight="medium">
            Extract Goals from Note
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 2 }} />

        {/* Content */}
        <Box sx={{ flex: 1, overflow: "auto" }}>
          {loading ? (
            <AILoadingMessages isActive={loading} onComplete={onLoadingComplete} />
          ) : goals.length > 0 ? (
            <ExtractedGoalsPanel
              goals={goals}
              participantId={participantId}
              noteId={noteId}
              onDismiss={onClose}
              onGoalsCreated={handleGoalsCreated}
            />
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 280,
                px: 2,
                textAlign: "center",
              }}
            >
              <PsychologyOutlined
                sx={{ fontSize: 48, color: "text.disabled", mb: 2 }}
              />
              <Typography variant="subtitle1" color="text.primary" gutterBottom>
                No goals found in this note
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ maxWidth: 360, mb: 3 }}
              >
                The note didn&apos;t contain extractable goals, or the content
                wasn&apos;t suitable for goal extraction.
              </Typography>
              <Button variant="outlined" onClick={onClose} size="small">
                Close
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  );
};

export default ExtractGoalsDrawer;
